import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { toast } from "sonner"

type Props = {
  companyId: string
}

export const useRelabelBackofficeCanonicalTopicsMutation = ({ companyId }: Props) => {
  return useMutation({
    mutationFn: async ({ canonicalTopicIds }: { canonicalTopicIds: string[] }) => {
      const { data } = await axios.post<{ data: { success: boolean; count: number } }>(
        "/backoffice/canonicalTopics/relabel",
        { companyId, canonicalTopicIds },
      )

      return data.data
    },
    onSuccess: ({ count }) => {
      toast.success(
        `Re-labeling started for ${count} topic(s) — refresh in a moment to see results`,
      )
    },
    onError: () => {
      toast.error("Failed to start re-labeling")
    },
  })
}
